import React, { useLayoutEffect, useEffect, useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import {
  IconButton,
  Typography,
  Grid,
  Tooltip
} from '@mui/material'
import { withStyles } from '@mui/styles'
import messageTime from 'utils/stringTimeHello'
import { Page } from 'components'
import { withRouter } from 'react-router-dom'
import { authActions, dashboardAction } from '../../_actions'
import CardAnexosPendentes from '../Dashboard/components/CardAnexosPendentes'
import CardObra from '../Dashboard/components/CardObra'
import { history } from './../../utils'
import CardObrasAindaNaoReceberamOrcamento from '../Dashboard/components/CardObrasAindaNaoReceberamOrcamento'
import CardHorasRecebimentoOrcamentos from '../Dashboard/components/CardHorasRecebimentoOrcamentos'
import CardInfosValues from './components/CardInfosValues'
import { CardMedicoesPendentes, CardObrasRecebendoOrcamentos, CardOrcamentosEnviados } from './components'
import CardListaObraInteresse from './components/CardListaObraInteresse'
import { LocalAtmOutlined, MonetizationOnOutlined, PriceCheck } from '@mui/icons-material';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import { HelpModal } from '../../components';
import { MANUAIS_CATEGORIAS } from '../../utils'

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2),
    backgroundRepeat: 'repeat'
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    textAlign: 'center'
  },
  cardItem: {
    display: 'flex'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(3)
  },
  greeting: {
    fontSize: '26px!important',
    fontWeight: '700!important',
    color: '#111827',
    [theme.breakpoints.down('sm')]: {
      fontSize: '22px!important'
    }
  },
  subtitle: {
    fontSize: '15px!important',
    color: '#6b7280',
    marginTop: '4px!important'
  },
  helpButton: {
    marginLeft: '6px!important',
    color: '#9ca3af!important',
    '&:hover': {
      color: '#015192!important',
      backgroundColor: 'rgba(1, 81, 146, 0.08)!important'
    }
  }
});

const Dashboard = (props) => {

  const { className, classes, ...rest } = props
  const { match: { params } } = props;
  const dispatch = useDispatch();
  const [pendentes, setPendentes] = useState(true);

  const [modalHelp, setModalHelp] = useState(false);
  const toggleModalHelp = () => setModalHelp(!modalHelp);

  const handleOpenModalHelp = () => {
    toggleModalHelp();
  }

  const user = useSelector((state) => state.authentication.user)

  useLayoutEffect(() => {
    dispatch(authActions.refresh())

  }, [])

  const { idOrgao } = useSelector(
    (state) => state.usuarioOrgao
  )

  useEffect(() => {
    let filterModel = {
      IdOrgao: idOrgao
    }
    dispatch(dashboardAction.getDashboard(filterModel));

  }, [idOrgao])

  useEffect(() => {
    let filterModel = {
      IdOrgao: idOrgao
    }
    dispatch(dashboardAction.getDashboard(filterModel));

  }, [])

  const handleClickOpenObrasPendentes = () => {
    history.push(`/obras`, pendentes)
  }

  return (
    <Page
      className={classes.root}
      title='Raiar - Dashboard'
    >
      <div {...rest} className={clsx(classes.root, className)}>
        <div className={classes.header}>
          <div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Typography component="h1" className={classes.greeting}>
                {messageTime()}, {user ? user.nome : ''}
              </Typography>
              {authActions.isGestor() ?
                <Tooltip title={'Ajuda'}>
                  <IconButton
                    aria-label="Ajuda"
                    onClick={() =>
                      handleOpenModalHelp()
                    }
                    size="small"
                    className={classes.helpButton}
                  >
                    <HelpOutlineRoundedIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
                : null}
            </div>
            <Typography component="h2" className={classes.subtitle}>
              {'Seja bem-vindo(a)! Confira o resumo dos seus indicadores.'}
            </Typography>
          </div>
          <CardHorasRecebimentoOrcamentos />
        </div>
        <Grid container spacing={2.5}>
          {(!authActions.isFiscal() && !authActions.isEmpresa()) &&
            <Grid item lg={3} sm={6} xs={12} className={classes.cardItem}>
              <CardObra onClick={() => handleClickOpenObrasPendentes()} />
            </Grid>
          }
          {(authActions.isGestor() || authActions.isEmpresa()) &&
            <Grid item lg={3} sm={6} xs={12} className={classes.cardItem}>
              {authActions.isGestor() ?
                <CardAnexosPendentes
                  onClick={() => history.push(`/empresasAnexos`)}
                />
                :
                <CardOrcamentosEnviados
                  onClick={() => history.push(`/obrasOrcamentos`)}
                />
              }
            </Grid>
          }
          <Grid item lg={3} sm={6} xs={12} className={classes.cardItem}>
            {(authActions.isGestor() || authActions.isFiscal()) ?
              <CardMedicoesPendentes
                onClick={() => history.push(`/obrasCronogramas`)}
              />
              :
              <CardObrasRecebendoOrcamentos
                onClick={() => history.push(`/obrasAguardandoOrcamento`)}
              />
            }
          </Grid>
          {authActions.isGestor() &&
            <Grid item lg={3} sm={6} xs={12} className={classes.cardItem}>
              <CardObrasAindaNaoReceberamOrcamento
                onClick={() => history.push(`/obrasAguardandoOrcamento`)}
              />
            </Grid>
          }
          {(authActions.isGestor() || authActions.isPrefeitura()) &&
            <>
              <Grid item lg={4} sm={6} xs={12} className={classes.cardItem}>
                <CardInfosValues
                  indicator="valorTotalEmpenhosEmAberto"
                  text="Valor de empenhos em aberto"
                  icon={<LocalAtmOutlined />}
                />
              </Grid>
              <Grid item lg={4} sm={6} xs={12} className={classes.cardItem}>
                <CardInfosValues
                  indicator="valorTotalEmpenhosPagos"
                  text="Valor de empenhos pagos"
                  icon={<PriceCheck />}
                />
              </Grid>
              <Grid item lg={4} sm={12} xs={12} className={classes.cardItem}>
                <CardInfosValues
                  indicator="valorTotalEmpenhos"
                  text="Valor total de empenhos"
                  icon={<MonetizationOnOutlined />}
                />
              </Grid>
            </>
          }
          {authActions.isEmpresa() &&
            <Grid item xs={12} sx={{ mt: 1 }}>
              <CardListaObraInteresse />
            </Grid>
          }
          {/*<Grid item xl={6} lg={6} md={6} xs={12}>*/}
          {/*  <GraficoObrasStatusChartCard />*/}
          {/*</Grid>*/}
          {/*<Grid item xl={6} lg={6} md={6} xs={12}>*/}
          {/*  <GraficoObrasPorMesChartCard />*/}
          {/*</Grid>*/}
        </Grid>
        {
          (modalHelp ?
            <HelpModal
              toggle={toggleModalHelp}
              modal={modalHelp}
              props={props}
              tela={MANUAIS_CATEGORIAS.DASHBOARD}
            />
            :
            null
          )
        }
      </div>
    </Page >
  )
}
Dashboard.propTypes = {
  classes: PropTypes.object.isRequired
}
const mapStateToProps = (state) => {
  return state
}
const connectedDashboardPage = withRouter(
  //connect(mapStateToProps, null, null, {
  //  pure: false
  //})(withStyles(styles)(Dashboard))
  connect(mapStateToProps, null, null)(withStyles(styles)(Dashboard))
)
export { connectedDashboardPage as Dashboard }
